import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { S1ButtonType } from '../s1-button/s1-button.component';
import { S1InputFileType } from '../s1-input-file/s1-input-file.component';
import { S1DownloadService } from '../s1-download.service';

@Component({
  selector: 's1-upload-section',
  templateUrl: './s1-upload-section.component.html',
  styleUrls: ['./s1-upload-section.component.scss']
})
export class S1UploadSection implements OnInit {

  @Input() formData: FormData;
  @Output() formDataChange = new EventEmitter<FormData>();
  @Input() disabled: boolean;
  @Input() allowAdd: boolean = true;
  @Input() acceptedFiles: S1InputFileType[];
  @Input() label: string = "'s1.button.selectAttachments'";

  s1ButtonType = S1ButtonType;

  files: File[] = [];

  constructor(private s1DownloadService: S1DownloadService) { }

  ngOnInit(): void { 
    this.files = [];
  }

  addFiles(files: FileList) {

    for (let i = 0; i < files.length; i++) {
      this.files.push(files[i]);
      this.formData.append(files[i].name, files[i]);
    }
    
    this.formDataChange.emit(this.formData);

  }

  remove(file: File) {

    this.files = this.files.filter(f => f.name != file.name);

    this.formData.delete(file.name);
    this.formDataChange.emit(this.formData);

  }

  show(file: File) {
    this.s1DownloadService.show(file, file.name);
  }

}
